module.exports = __webpack_public_path__ + "img/336x28O.510306f2.svg";